import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
export interface table {
  RaisonAdr: string;
  NatureDeTravail: string;
  AgentsNocifs: string;
  periode: string;
}
const Listtable: table[] = []

@Component({
  selector: 'app-maladi-prof',
  templateUrl: './maladi-prof.component.html',
  styleUrls: ['./maladi-prof.component.scss']
})


export class MaladiProfComponent implements OnInit {
  @ViewChild('frmadd', { static: false }) add;
  @ViewChild('frmDelete', { static: false }) frmDelete;
  //dialog
  du
  au
  rsCNSS
  natTrv
  agentNs
  displayedColumns: string[] = ['RaisonAdr', 'NatureDeTravail', 'AgentsNocifs', 'periode', 'Action'];
  dataSource: MatTableDataSource<table>;
  listTable = []
  //variable dialogue Employeur
  RS = null;
  nCnss = null;
  adresse = null;
  codepostal = null;
  nTel = null;
  NatActivite = null;
  //variable dialogue victim
  NumAffec = null;
  NpVic = null;
  PrPere = null;
  njFille = null;
  nat = null;
  Sexe = null;
  dateNais = null;
  LieuNai = null;
  cin = null;
  adresseDom = null;
  CodePostal = null;
  dateEmb = null;
  qualifPro = null;
  Status = null;
  EmpHabit = null;
  depuis = null;
  adrHabTrav = null;
  //variable dialogue Mp
  desMal = null;
  nTabCor = null;
  consMal = null;
  dateMal = null;
  natTrav = null;
  agentNoc = null;
  dateAgentNoct = null;
  entArret = null;
  //variable dialogue arretTravail
  dateArret = null;
  salaireMaintenu = null;
  dureeArret = null;
  montantArret = null;
  parArret = null;
  //variable tableau
  nompSous = null;
  postSous = null;
  faitA = null;
  le = null;
  //spanDate
  dateNaisSpan
  dateEmbSpan
  dateMalSpan
  dateAgenNocSpan
  dateArretSpan
  dateLeSpan
  impTop
  ListSoc;
  TabTop = ["1710px", "1776px", "1842px", "1904px", "1966px", "2028px", "2094px"]
  api='https://backend-uniges.pmc.tn/api/'
  persoRech
  constructor(public generalService: GeneralService, private datePipe: DatePipe) {

      //console.log(res);
      this.impTop =0

    this.generalService.rechercheTable2('API_Soc').subscribe(res => {
      //console.log(res);
      this.ListSoc = res
    })
  }
  persoSousRech
  persoSousSelected
  blurPersoSS(id)
  {
    this.generalService.getDS('avtPerso',id).subscribe(res => {
      this.persoSousSelected=res
      this.nompSous=this.persoSousSelected.perso[0].Perso_Nom +' '+this.persoSousSelected.perso[0].Perso_Prenom
      this.postSous=this.persoSousSelected.perso[0].Perso_Emploi
    })
  }
  prsoSelected
  blurPerso(event)
  {
    console.log(event);
    this.generalService.getDS('avtPerso',event).subscribe(res => {
      console.log(res);
      this.prsoSelected = res
      this.NumAffec=this.prsoSelected.perso[0].Perso_N_CNSS
      this.NpVic=this.prsoSelected.perso[0].Perso_Nom +' '+this.prsoSelected.perso[0].Perso_Prenom
      this.PrPere=this.prsoSelected.perso[0].XPrenomPere
      this.njFille=this.prsoSelected.perso[0].XNomJF
      this.nat=this.prsoSelected.perso[0].Perso_Nationalite
      if(this.prsoSelected.perso[0].Perso_Sex==1)
        this.Sexe='H'
      else if(this.prsoSelected.perso[0].Perso_Sex==2)
      {
      this.Sexe='F'
      }
      this.dateNais=new Date(this.prsoSelected.perso[0].Perso_DateNaissance)
      this.dateNaisSpan = this.datePipe.transform(this.dateNais, 'MM/dd/YYYY')
      this.LieuNai=this.prsoSelected.perso[0].XLieuNaissance
      this.cin=this.prsoSelected.perso[0].Perso_CIN
      this.adresseDom=this.prsoSelected.perso[0].Perso_Adresse
      this.dateEmb=new Date(this.prsoSelected.perso[0].Perso_DateDeb)
      this.dateEmbSpan = this.datePipe.transform(this.dateEmb, 'MM/dd/YYYY')
      this.qualifPro=this.prsoSelected.perso[0].XqualProfessionel
      this.Status=this.prsoSelected.perso[0].Perso_Status
      this.EmpHabit=this.prsoSelected.perso[0].Perso_Emploi
      this.depuis=new Date(this.prsoSelected.perso[0].XdateDeclaration)
      this.datedepuis = this.datePipe.transform(this.depuis, 'MM/dd/YYYY')
    })
  }
  depuisChange()
  {
    this.datedepuis = this.datePipe.transform(this.depuis, 'MM/dd/YYYY')
  }
  datedepuis
  ngOnInit(): void {
    this.initialise()
    this.initialiseDialogue()
  }
  initialiseDialogue() {
    try {
      this.rsCNSS = ""
      this.natTrv = ""
      this.agentNs = "";
      (<HTMLInputElement>document.getElementById("au")).value = null;
      (<HTMLInputElement>document.getElementById("du")).value = null;
    }
    catch (error) {

    }
  }
  elmentToModif
  modifer(param) {
    this.elmentToModif = param
    console.log(param);
    this.DialogeOpenModif = true
    this.openDialogAdd(param)

  }
  supprimer() {
    this.listTable.forEach((element, i) => {
      if (element == this.toDelete) {
        this.listTable.splice(i, 1)
      }
    });
    this.reloadTable()
  }
  validform() {
    let test = true
    if (!this.rsCNSS || !this.natTrv || !this.agentNs || !(<HTMLInputElement>document.getElementById("du")).value || !(<HTMLInputElement>document.getElementById("au")).value) {
      test = false
    }
    return test
  }
  save() {
    if (!this.DialogeOpenModif) {
      if (this.validform()) {
        this.du = (<HTMLInputElement>document.getElementById("du")).value;
        this.au = (<HTMLInputElement>document.getElementById("au")).value;
        let newline = {
          RaisonAdr: this.rsCNSS,
          NatureDeTravail: this.natTrv,
          AgentsNocifs: this.agentNs,
          du: this.du,
          au: this.au,
          periode: 'Du ' + this.du + ' Au ' + this.au,
        }
        console.log(newline);
        // this.getInterfaceTab();
        if (this.listTable.length < 7) {
          this.listTable.push(newline)
          this.reloadTable()
          this.styleElment()
        }
        this.initialiseDialogue()
      }
      else
        this.generalService.dialogSuccess(
          'Remlir les champs',
          false
        );
    }
    else {
      if (this.validform()) {
        this.du = (<HTMLInputElement>document.getElementById("du")).value;
        this.au = (<HTMLInputElement>document.getElementById("au")).value;
        this.listTable.forEach((element, i) => {
          if (element.AgentsNocifs == this.elmentToModif.AgentsNocifs &&
            element.NatureDeTravail == this.elmentToModif.NatureDeTravail &&
            element.RaisonAdr == this.elmentToModif.RaisonAdr &&
            element.au == this.elmentToModif.au &&
            element.du == this.elmentToModif.du) {
            element.AgentsNocifs = this.agentNs
            element.NatureDeTravail = this.natTrv
            element.RaisonAdr = this.rsCNSS
            element.au = this.au
            element.du = this.du
            element.periode = 'Du ' + this.du + ' Au ' + this.au
          }
        })
      }
      else
        this.generalService.dialogSuccess(
          'Remlir les champs',
          false
        );

    }
  }
  initialise() {
    this.StyleSpanrsCNSS = {
      position: "absolute",
      top: '1710px',
      left: '125px',
      'font-size': '30px'
    }
    this.StyleSpannatTrv = {
      position: "absolute",
      top: '1710px',
      left: '628px',
      'font-size': '30px',
    }
    this.StyleSpanAgent = {
      position: "absolute",
      top: '1710px',
      left: '902px',
      'font-size': '30px'
    }
    this.StyleSpanDu = {
      position: "absolute",
      top: '1710px',
      left: '1153px',
      'font-size': '25px'
    }
    this.StyleSpanAu = {
      position: "absolute",
      top: '1710px',
      left: '1280px',
      'font-size': '25px',
    }
  }
  StyleSpanrsCNSS
  StyleSpannatTrv
  StyleSpanAgent
  StyleSpanDu
  StyleSpanAu

  reloadTable() {
    this.dataSource = new MatTableDataSource(this.listTable)
  }
  styleElment() {
    // var ln = Math.ceil(this.listTable.length / 5)
    // if (ln > 1) {
    //   for (let i = 1; i <= ln; i++) {
    //     let t = []
    //     let posTop = 384 + this.Pagediff * i
    //     t.push(posTop + 'px')
    //     for (let x = 1; x <= 4; x++) {
    //       posTop += 63
    //       t.push(posTop + 'px')
    //     }
    //     t.forEach(element => {
    //       this.TabTop.push(element)
    //     });
    //   }
    // }
    this.listTable.forEach((element, i) => {
      this.StyleSpanrsCNSS.top = this.TabTop[i]
      element.StyleSpanrsCNSS = { ...this.StyleSpanrsCNSS }

      this.StyleSpannatTrv.top = this.TabTop[i]
      element.StyleSpannatTrv = { ...this.StyleSpannatTrv }

      this.StyleSpanAgent.top = this.TabTop[i]
      element.StyleSpanAgent = { ...this.StyleSpanAgent }

      this.StyleSpanAu.top = this.TabTop[i]
      element.StyleSpanAu = { ...this.StyleSpanAu }

      this.StyleSpanDu.top = this.TabTop[i]
      element.StyleSpanDu = { ...this.StyleSpanDu }
    });
    this.reloadTable()
  }
  close() {
    this.generalService.dialog.afterAllClosed.subscribe(() => { })
  }
  DialogeOpenModif = false
  openDialogAdd(param) {
    console.log(param);
    if (param == 1) {
      this.generalService.dialog.open(this.add);
      this.generalService.dialog.afterAllClosed.subscribe(() => {
        this.initialiseDialogue()
      });
      this.DialogeOpenModif = false
    }
    else {
      this.generalService.dialog.open(this.add);
      this.rsCNSS = param.RaisonAdr
      this.agentNs = param.AgentsNocifs
      this.natTrv = param.NatureDeTravail;
      // this.du=param.periode.du
      // this.au=param.periode.au
      (<HTMLInputElement>document.getElementById("du")).value = param.du;
      (<HTMLInputElement>document.getElementById("au")).value = param.au;
      this.generalService.dialog.afterAllClosed.subscribe(() => {
        //this.initialiseDialogue()
      });
      this.DialogeOpenModif = true
    }

  }
  societeName
  lastIdSoc
  selectSoc(soc) {
    this.societeName = soc
    this.ListSoc.forEach(element => {
      if (element.SOC_RS == soc) {
        console.log(element);
        this.lastIdSoc=element.SOC_ID
        this.nCnss = element.SOC_AFFCNSS
        this.RS = element.SOC_RS
        this.codepostal = element.SOC_CodePostal
        this.nTel = element.SOC_NumTel
        this.adresse = element.SOC_Adresse
        this.NatActivite=element.XSoc_Activite
      }
    });
  }
  toDelete
  openDialogueDelete(param) {
    console.log(param);
    this.generalService.dialog.open(this.frmDelete, { width: '20vw', disableClose: true });
    this.toDelete = param
  }
  imprimer() {
    this.generalService.printContentsTest("mp", "../../assets/print/dec-mp.jpg")
  }
  dateNaisChange() {
    this.dateNaisSpan = this.datePipe.transform(this.dateNais, 'MM/dd/YYYY')
  }
  dateEmbChange() {
    this.dateEmbSpan = this.datePipe.transform(this.dateEmb, 'MM/dd/YYYY')
  }
  dateLe() {
    this.dateLeSpan = this.datePipe.transform(this.le, 'MM/dd/YYYY')
  }

  dateMalChange() {
    this.dateMalSpan = this.datePipe.transform(this.dateMal, 'MM/dd/YYYY')
  }
  dateAgenChange() {
    this.dateAgenNocSpan = this.datePipe.transform(this.dateAgentNoct, 'MM/dd/YYYY')
  }
  dateArretChange() {
    this.dateArretSpan = this.datePipe.transform(this.dateArret, 'MM/dd/YYYY')
  }
  societeId() {
    let id = null
    this.ListSoc.forEach(element => {
      if (element.SOC_RS == this.societeName) {
        id = element.SOC_ID;
      }
    });
    return id
  }
  enregistrer() {
    this.generalService.getDS('CNAM_Maladie_Pro').subscribe(res => {
      console.log(res);
      res['CNAM_Maladie_Pro'][0].Employeur_Id = this.societeId()
      res['CNAM_Maladie_Pro'][0].Perso_Id =  this.prsoSelected.perso[0].Perso_Matricule
      //malPro
      res['CNAM_Maladie_Pro'][0].Mal_Designation = this.desMal
      res['CNAM_Maladie_Pro'][0].Mal_N_Tableau = this.nTabCor
      res['CNAM_Maladie_Pro'][0].Mal_Constatation = this.consMal
      res['CNAM_Maladie_Pro'][0].Mal_Date_Constat = this.dateMalSpan
      res['CNAM_Maladie_Pro'][0].Mal_Nature_Travail = this.natTrav
      res['CNAM_Maladie_Pro'][0].Mal_Cessation = this.agentNoc
      res['CNAM_Maladie_Pro'][0].Mal_Date_cessation = this.dateAgenNocSpan
      res['CNAM_Maladie_Pro'][0].Mal_Arret_travail = this.entArret

      //Arret
      res['CNAM_Maladie_Pro'][0].Mal_Salaire_Maint = this.salaireMaintenu
      res['CNAM_Maladie_Pro'][0].Mal_Montant_periode = this.parArret
      res['CNAM_Maladie_Pro'][0].Mal_Montant = this.montantArret
      res['CNAM_Maladie_Pro'][0].Mal_Duree = this.dureeArret
      res['CNAM_Maladie_Pro'][0].Mal_DateArret = this.dateArretSpan

      //
      res['CNAM_Maladie_Pro'][0].Mal_Soussignieinfo = this.nompSous
      res['CNAM_Maladie_Pro'][0].Mal_SoussigniePoste = this.postSous
      res['CNAM_Maladie_Pro'][0].Date_signature = this.dateLeSpan
      res['CNAM_Maladie_Pro'][0].ville_signiature = this.faitA
      res['CNAM_Maladie_Pro'][0].Date_Create = this.dateLeSpan
      if (this.formFill()) {
        this.generalService.postDs(res).subscribe(resp => {
          console.log(resp);
          this.generalService.dialogSuccess(
            'Ajout avec succes',
            true
          );
        })
      }
      else {
        this.generalService.dialogSuccess(
          'Remplir les champ',
          false
        );
      }
    },(error)=>{
        this.generalService.dialogSuccess(
          'Probléme de connexion',
          false
        );
    })
  }
  formFill() {
    let test = false
    if (this.nompSous && this.postSous && this.faitA && this.dateLeSpan && this.CodePostal) {
      test = true
    }
    return test
  }

  
selectArret(event)
{
  this.entArret=event.value
  console.log(this.entArret);
  
}
}
